import React, { useState, useEffect } from "react";
import "./RatingsTable.css";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const RatingsTable = ({
  courseRating,
  slopeRating,
  totalPar,
  courseHandicap,
}) => {
  const handicapTableWrapperRef = useRef(null);
  const { t } = useTranslation();
  const [columns, setColumns] = useState(1);

  useEffect(() => {
    const updateColumns = () => {
      if (window.innerWidth >= 1200) {
        setColumns(3);
      } else if (window.innerWidth >= 768) {
        setColumns(2);
      } else {
        setColumns(1);
      }
    };
    window.addEventListener("resize", updateColumns);
    updateColumns(); // Initial check

    return () => window.removeEventListener("resize", updateColumns);
  }, []);

  const rows = [];
  let previousCourseHandicap = null;
  let fromHcp = -5;
  const maxHcp = 54;

  for (let i = 10*fromHcp; i <= 10*maxHcp; i++) {
    let hcp = i / 10;

    const raw = (hcp * slopeRating) / 113 + (courseRating - totalPar);
    const courseHandicap = Math.round(Number(raw.toFixed(10)));

    if (courseHandicap !== previousCourseHandicap) {
      if (previousCourseHandicap !== null) {
        const toHcp = hcp - 0.1;
        rows.push({
          fromHcp: fromHcp.toFixed(1),
          courseHandicap: previousCourseHandicap,
          toHcp: toHcp.toFixed(1),
        });
      }
      fromHcp = hcp;
      previousCourseHandicap = courseHandicap;
    }
  }

  rows.push({
    fromHcp: fromHcp.toFixed(1),
    courseHandicap: previousCourseHandicap,
    toHcp: String(maxHcp.toFixed(1)),
  });

  const rowsPerColumn = Math.ceil(rows.length / columns);

  return (
    <div className="glfr-handicap-table-wrapper" ref={handicapTableWrapperRef}>
      <div className="flex-container">
        {Array.from({ length: columns }).map((_, i) => {
          const columnRows = rows.slice(
            i * rowsPerColumn,
            (i + 1) * rowsPerColumn
          );
          return (
            <div key={i} className="flex-column">
              <table className="glfr-ratings-table">
                <thead>
                  <tr className="glfr-ratings-header-row">
                    <th className="glfr-ratings-header glfr-ratings-cell-center">
                      {t("from")}
                    </th>
                    <th className="glfr-ratings-header glfr-ratings-cell-center">
                      {t("to")}
                    </th>
                    <th className="glfr-ratings-header glfr-ratings-cell-center">
                      {t("course_handicap")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {columnRows.map((row, index) => (
                    <tr
                      key={index}
                      className={`glfr-ratings-row ${
                        courseHandicap === row.courseHandicap ? "highlight" : ""
                      }`}
                    >
                      <td className="glfr-ratings-cell glfr-ratings-cell-center">
                        {row.fromHcp}
                      </td>
                      <td className="glfr-ratings-cell glfr-ratings-cell-center">
                        {row.toHcp}
                      </td>
                      <td className="glfr-ratings-cell glfr-ratings-cell-center glfr-ratings-cell-handicap">
                        {row.courseHandicap}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RatingsTable;
